import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { PdfTemplates } from "../models/reportFooter/pdfTemplates";
import { PdfTemplateUpdateByIdRequestDto } from "../models/reportFooter/pdfTemplateUpdateByIdRequestDto";
import { ShippingMethod } from "../models/shared/shippingMethod";

@Injectable({
  providedIn: "root",
})
export class ManagementService {
  private managementURL = environment.baseUrl + "/SamplePOMangement";
  private commonBaseURL = environment.baseUrl + "/Common";
  private samplePOMangementBaseURL = environment.baseUrl + "/SamplePOMangement";
  constructor(private _http: HttpClient) {}

  shippingMethodOrderUpdate(
    payload: ShippingMethod[]
  ): Observable<GenericResponseDto<ShippingMethod[]>> {
    return this._http.post<GenericResponseDto<ShippingMethod[]>>(
      this.samplePOMangementBaseURL + "/UpdateShippingMethodOrder",
      payload
    );
  }

  GetPdfTemplates(): Observable<GenericResponseDto<PdfTemplates[]>> {
    return this._http.get<GenericResponseDto<PdfTemplates[]>>(
      `${this.commonBaseURL}/GetPdfTemplates`
    );
  }

  PdfTemplateUpdateById(
    payload: PdfTemplateUpdateByIdRequestDto
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.commonBaseURL + "/PdfTemplateUpdateById",
      payload
    );
  }
}
